/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import React from 'react';

import { Button, Modal } from '@mairistem/composants';

const LIBELLES_DECLARATION: Record<string, string> = {
  modificative: 'une déclaration modificative',
  dissolution: 'une déclaration de dissolution',
};

interface DeclarationNonEnregistreeModalProps {
  /** Type de déclaration en cours de saisie (`modificative`, `dissolution`) */
  declarationType?: string | null;
  /** Numéro du PACS sélectionné, affiché à titre d'information */
  numeroPacs?: string;
  onClose: () => void;
  onOpenFiche: () => void;
}

/**
 * Affichée lorsque l'utilisateur sélectionne, pour une modificative ou une
 * dissolution, un PACS dont la déclaration n'a pas été enregistrée au registre.
 */
const DeclarationNonEnregistreeModal = (
  props: DeclarationNonEnregistreeModalProps,
) => {
  const { declarationType, numeroPacs, onClose, onOpenFiche } = props;

  const libelleDeclaration =
    LIBELLES_DECLARATION[declarationType ?? ''] ?? 'une nouvelle déclaration';
  const libellePacs = numeroPacs ? `le PACS n° ${numeroPacs}` : 'ce PACS';

  return (
    <Modal open data-testid="declaration-non-enregistree-modal">
      <Modal.Header>Déclaration de PACS non enregistrée</Modal.Header>
      <Modal.Content>
        <p>
          {`Impossible d'établir ${libelleDeclaration} sur ${libellePacs} : l'enregistrement de sa déclaration n'a pas été confirmé.`}
        </p>
        <p>
          Confirmez l&apos;enregistrement de la déclaration depuis la fiche du
          PACS, puis reprenez la saisie.
        </p>
      </Modal.Content>
      <Modal.Actions>
        <Button
          basic
          size="small"
          icon="cancel"
          content="Annuler"
          data-testid="declaration-non-enregistree-annuler"
          onClick={onClose}
        />
        <Button
          primary
          content="Accéder à la fiche du PACS"
          data-testid="declaration-non-enregistree-fiche"
          onClick={onOpenFiche}
        />
      </Modal.Actions>
    </Modal>
  );
};

export default DeclarationNonEnregistreeModal;
